import { render, staticRenderFns } from "./BosOverviewTable.vue?vue&type=template&id=c00eaaac&scoped=true"
import script from "./BosOverviewTable.vue?vue&type=script&lang=js"
export * from "./BosOverviewTable.vue?vue&type=script&lang=js"
import style0 from "./BosOverviewTable.vue?vue&type=style&index=0&id=c00eaaac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00eaaac",
  null
  
)

export default component.exports